import {
    ApiLocation,
    getApmEnvironment,
    getCrosstalkApiHost,
    getOnPremApiHost,
    getNQSApiHost,
    getDDVApiHost,
    getPSCHostAndPort,
    getFeatureFlagsApiHost,
    getCFBApiHost,
    getTrebekApiHost,
    getWebauthApiHost,
} from '@ddv/http';

import { baseEnvironment } from './environment.base';

export const environment = {
    ...baseEnvironment,
    production: true,
    apm: {
        environment: getApmEnvironment(),
        active: true,
    },
    onPremApiHost: getOnPremApiHost(),
    replaceHostInMetadataAndQueryURLs: false,
    replaceHostInActionsURL: false,
    removeRestFromActionPath: false,
};

(environment.ddvMWLocation as ApiLocation).hostAndPort = 'on-prem';
(environment.monitorMWLocation as ApiLocation).hostAndPort = 'on-prem';
(environment.trebekApiLocation as ApiLocation).hostAndPort = getTrebekApiHost();
(environment.flagsApiLocation as ApiLocation).hostAndPort = getFeatureFlagsApiHost();
(environment.wauthApiLocation as ApiLocation).hostAndPort = getWebauthApiHost();
(environment.wauthApiLocation as ApiLocation).rootUri = '/webauth/api/';
(environment.xtlkApiLocation as ApiLocation).hostAndPort = getCrosstalkApiHost();
(environment.pscLocation as ApiLocation).hostAndPort = getPSCHostAndPort();
(environment.nqsApiLocation as ApiLocation).hostAndPort = getNQSApiHost();
(environment.cfbApiLocation as ApiLocation).hostAndPort = getCFBApiHost();
(environment.ddvApiLocation as ApiLocation).rootUri = '/ddv/api/';
(environment.ddvApiLocation as ApiLocation).hostAndPort = getDDVApiHost();
(environment.monitorApiLocation as ApiLocation).rootUri = '/ddv/';
(environment.monitorApiLocation as ApiLocation).hostAndPort = getDDVApiHost();
(environment.reverseProxyLocation as ApiLocation).hostAndPort = getTrebekApiHost();
